<template>
  <div class="SubscriptionDetailsPage">
    <transition name="fade" mode="out-in">
      <app-loading
        class="fullscreen"
        v-if="isLoading"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>
    <template v-if="!isLoading">
      <header-banner
        :img-src-mobile="subscriptionDetails.headerImageUrlOfMobile"
        :img-src-desktop="subscriptionDetails.headerImageUrlOfDesktop"
      />

      <div class="DetailsSection container">
        <router-link to="/my-account" class="BackToAccountView">
          ‹ {{ $t('common.breadcrumbNav.accountOverview', 'Account overview') }}
        </router-link>

        <template v-if="!onlyReplenishment">
          <div class="SubscriptionDetailsPage_product">
            <product
              class="SubscriptionDetailsPage_product_bundle"
              :number="subscriptionDetails.number"
              :isBCBSSubscription="subscriptionDetails.isBCBSSubscription" 
              :name="subscriptionDetails.title"
              :image="subscriptionDetails.imageUrl"
              :monthly-charge="subscriptionDetails.totalCharge.monthly"
              :quarterly-charge="subscriptionDetails.totalCharge.quarterly"
              :semi-annual-charge="subscriptionDetails.totalCharge.semiAnnual"
              :specific-months-charges="subscriptionDetails.totalCharge.specificMonths"
              :next-payment-date="subscriptionDetails.nextPaymentDate"
              :return-info-status="(subscriptionDetails.ratePlans.length===1 && tryBuyReturnDetails &&
              tryBuyReturnDetails.returnStatus !== 'None') ? tryBuyReturnDetails && tryBuyReturnDetails.returnStatus : null"
              :start-date="subscriptionDetails.startDate"
              :end-date="(subscriptionDetails.isCancelled) ? subscriptionDetails.endDate : null"
              :returning-status="(subscriptionDetails.ratePlans.length===1 && tryBuyReturnDetails &&
              (tryBuyReturnDetails.unreturnableReason==='SubscriptionCancelled' && tryBuyReturnDetails.returnStatus!=='Returning')) ||
                (subscriptionDetails.ratePlans.length===1 &&
              subscriptionDetails.ratePlans[0].status === 'Cancel') ? $t('subscription_return.returnStatus.cancelled', 'Cancelled') : null"
            >
              <template slot="more-info" v-if="subscriptionDetails.ratePlans.length===1">
                <div class="returnTips">
                  <p class="tips_returnStatus" ref="tips_returnStatus" v-if="!subscriptionDetails.isCancelled && (tryBuyReturnDetails && tryBuyReturnDetails.returnStatus === 'Returning')" v-once>
                    <span>{{ $t('subscription_details.onlyDevice.returning.tips', 'As soon as we have received the product back, your subscription will be cancelled and payments will be stopped') }}</span>
                  </p>
                </div>
              </template>
            </product>
            <hr v-if="subscriptionDetails.ratePlans.length>1">
            <div class="flex product_subset_detail" v-if="subscriptionDetails.ratePlans.length>1">
              <div class="col-md-6" v-for="(ratePlan, index) in subscriptionDetails.ratePlans" :key="index">
                <div class="bundle-ratePlan">
                  <!-- return-info-status is device status,  returning-status is return status-->
                  <product
                    :name="ratePlan.name"
                    :isBCBSSubscription="subscriptionDetails.isBCBSSubscription" 
                    :image="ratePlan.imageUrl"
                    :one-time-charge="ratePlan.oneTimeCharge"
                    :monthly-charge="ratePlan.monthlyCharge"
                    :quarterly-charge="ratePlan.quarterlyCharge"
                    :semi-annual-charge="ratePlan.semiAnnualCharge"
                    :specific-months-charges="ratePlan.specificMonthsCharges"
                    :list-shipping-frequency="((ratePlan.status !== 'Cancel' && ratePlan.modelType === 'Replenishment') &&
                    !!bundlesReplenishmentFrequency.type) ? bundlesReplenishmentFrequency : null"
                    :pay-in-full-date="ratePlan.payInFullDate"
                    :subscription-detail-next-shipment-date="(ratePlan.modelType === 'Replenishment' &&
                    (!ratePlan.cancellationDate || subscriptionDetails.ableToResumeReplenishment && subscriptionDetails.resumedReplenishmentDate)) &&
                    !replenishmentPauseWithIndefineDate ? subscriptionDetails.nextShipmentDate : null"
                    :subscription-detail-replenishment-next-shipment-date="(ratePlan.modelType === 'Replenishment' &&
                    replenishmentPauseWithIndefineDate) ? true : null"
                    :status-repend="(ratePlan.modelType !== 'Replenishment' &&
                    ratePlan.status !== 'Cancel') ? ratePlan.status : null"
                    :device-return-status="((ratePlan.modelType !== 'Replenishment') && ratePlan.status !== 'Cancel')
                    ? tryBuyReturnDetails && tryBuyReturnDetails.returnStatus : null"
                    :device-return-request-date="((ratePlan.modelType !== 'Replenishment') &&
                    ratePlan.status !== 'Cancel') ? tryBuyReturnDetails && tryBuyReturnDetails.returnCreatedDate : null"
                    :device-return-canceled-date="(ratePlan.modelType !== 'Replenishment') ? tryBuyRatePlan.cancellationDate : null"
                    :replenshipment-return-status="((ratePlan.modelType === 'Replenishment') &&
                    ratePlan.status !== 'Cancel') ? replenishmentReturnDetails && replenishmentReturnDetails.returnStatus : null"
                    :replenshipment-return-request-date="((ratePlan.modelType === 'Replenishment') &&
                    ratePlan.status !== 'Cancel') ? replenishmentReturnDetails && replenishmentReturnDetails.returnCreatedDate : null"
                    :replenshipment-return-canceled-date="(ratePlan.modelType === 'Replenishment') ? ratePlan.cancellationDate : null"
                    :device-returning-status="(ratePlan.status === 'Cancel' &&
                    ratePlan.modelType !== 'Replenishment') ? $t('subscription_return.returnStatus.cancelled', 'Cancelled') : null"
                    :replenshipment-returning-status="(((subscriptionDetails.status === 'Paused' &&
                    (replenishmentReturnDetails && replenishmentReturnDetails.returnStatus !=='Returning'))) &&
                    ratePlan.modelType === 'Replenishment' && ratePlan.status !== 'Cancel') ? subscriptionDetails.status : null"
                    :replenshipment-cancel-status="(((subscriptionDetails.status && ratePlan.status === 'Cancel')) &&
                    ratePlan.modelType === 'Replenishment') ? $t('subscription_return.returnStatus.cancelled', 'Cancelled') : null"
                  >
                    <template slot="more-info">
                      <div>
                        <p class="Product_returnCreateDate info_item Product_info_align" v-if="ratePlan.cancellationDate && ratePlan.status === 'Cancel'">
                          <span>
                            {{ $t('subscription_return.return.cancelConfirmDate', 'Cancellation confirmed') }}:
                          </span>
                          <span>{{ ratePlan.cancellationDate | formatLocalDate }}</span>
                        </p>
                      </div>
                    </template>
                  </product>
                  <div class="returnTips" v-if="(ratePlan.modelType !== 'Replenishment') && (tryBuyReturnDetails && tryBuyReturnDetails.returnStatus ==='Returning') && !subscriptionDetails.isCancelled && ratePlan.status !== 'Cancel'">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_return.return.waitingCanceledTips', 'As soon as we have received your product, your subscription will be cancelled and payments will be stopped.') }}
                      </span>
                    </p>
                  </div>
                  <div class="returnTips" v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType === 'ReplenishmentStandard') && (replenishmentReturnDetails && replenishmentReturnDetails.returnStatus ==='Returning') && !subscriptionDetails.isCancelled && ratePlan.status !== 'Cancel'">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_return.return.replenishment.returning.tips', 'Your subscription is cancelled, and you will no longer be charged or receive recurring shipments. You will be refunded as soon as we have received your product(s).') }}
                      </span>
                    </p>
                  </div>
                  <div class="pause_tips">
                    <!-- choice indefine date to pause subscription -->
                    <p
                      class="tips_returnStatus"
                      v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && replenishmentPauseWithIndefineDate"
                      v-once>
                      <span>
                        {{ $t('subscription_details.pauseSubscription.tipsOne', 'Subscription succesfully paused. You can manually resume your subscription anytime.') }}
                      </span>
                    </p>
                    <!-- choice specifc date to pause subscription  -->
                    <p
                      class="tips_returnStatus"
                      v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && replenishmentPauseWithSpecifcDate"
                      v-once>
                      <span>
                        {{ $t('subscription_details.pauseSubscription.tipsTwo', 'Subscription succesfully paused. Your subscription will resume on') }} <b> {{ specificDateFormat }}. </b> {{ $t('subscription_details.pauseSubscription.subTipsTwo', 'You can manually resume your subscription anytime.') }}
                      </span>
                    </p>
                    <!-- do pause subscription -->
                    <p
                      class="tips_returnStatus"
                      v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && replenishmentPauseSubscriptionCommonTips"
                      v-once>
                      <span>
                        {{ $t('subscription_details.pauseSubscription.tipsThree', 'Please note that you can only change your subscription again after the next shipment') }}
                      </span>
                    </p>
                    <!-- do resume  -->
                    <p
                      class="tips_returnStatus"
                      v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && resumeCommonTips">
                      <span>
                        {{ $t('subscription_details.resumeSubscription.successResume.tips', 'Subscription succesfully resumed. Your next shipment is planned for') }} <b> {{ nextShippingDate || resumedNextShippingDate }}. </b>
                      </span>
                    </p>
                  </div>
                  <div class="returnTips">
                    <p
                      class="tips_returnStatus"
                      v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && displayCancellationTips"
                      v-once>
                      <span
                        class="tips_replenshipment_cancel"
                        v-html="$t('subscription_details.accordion.popUp.cancellation.content',{
                          paidAmount: subscriptionDetails.paidAmountOfCancelledShipment,
                          remainingAmount: subscriptionDetails.totalAmountOfCancelledShipment - subscriptionDetails.paidAmountOfCancelledShipment,
                          price: subscriptionDetails.priceOfCancelledShipment,
                          finalPaymentDate: replenishmentFinalPaymentDate
                      })"></span>
                    </p>
                  </div>
                  <div class="changeProductSuccess" v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && displayChangeReplenishmentSuccessTips.display">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.tips', 'Product type successfully changed to') }}
                        <b>{{ displayChangeReplenishmentSuccessTips.name }}</b>.
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.subTips', 'Your new price') }}
                        <span v-if="ratePlan.monthlyCharge.original && ratePlan.monthlyCharge.original > 0"> {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
                        <span v-if="ratePlan.quarterlyCharge.original && ratePlan.quarterlyCharge.original > 0">{{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
                        <span v-if="ratePlan.semiAnnualCharge.original && ratePlan.semiAnnualCharge.original > 0">{{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
                        <template v-if="ratePlan.specificMonthsCharges.length >0 ">
                          <span class="Product_price info_item" v-for="(specificCharge, index) in ratePlan.specificMonthsCharges" :key="index">
                            <template v-if="specificCharge.amount.original">
                              <span> {{ specificCharge.months }} {{ $t('common.product.price.specificMonths', 'months') }}</span>
                            </template>
                          </span>
                        </template>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.successwill', ' will be') }}
                        <b>{{ displayChangeReplenishmentSuccessTips.price | formatCurrency(true) }}</b>
                        <span> {{ $t('subscription_details.modifyAccrodion.changeReplenishment.successeffective', ' effective from ') }} {{ subscriptionDetails.nextShipmentDate | formatLocalDate }} </span>
                      </span>
                    </p>
                  </div>
                  <div class="changeProductSuccess" v-if="(ratePlan.modelType === 'Replenishment' || ratePlan.modelType ==='ReplenishmentStandard') && showReplenishmentMsg && (ratePlan.amendmentReason === 'ChangeReplenishment-Renew') && !displayChangeReplenishmentSuccessTips.display">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.tips', 'Product type successfully changed to') }}
                        <b>{{ ratePlan.name }}</b>.
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.subTips', 'Your new price') }}
                        <span v-if="ratePlan.monthlyCharge.original && ratePlan.monthlyCharge.original > 0"> {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
                        <span v-if="ratePlan.quarterlyCharge.original && ratePlan.quarterlyCharge.original > 0">{{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
                        <span v-if="ratePlan.semiAnnualCharge.original && ratePlan.semiAnnualCharge.original > 0">{{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
                        <template v-if="ratePlan.specificMonthsCharges.length >0 ">
                          <span class="Product_price info_item" v-for="(specificCharge, index) in ratePlan.specificMonthsCharges" :key="index">
                            <template v-if="specificCharge.amount.original">
                              <span> {{ specificCharge.months }} {{ $t('common.product.price.specificMonths', 'months') }}</span>
                            </template>
                          </span>
                        </template>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.successwill', ' will be') }}
                        <span v-if="ratePlan.monthlyCharge.original && ratePlan.monthlyCharge.original > 0"> <b> {{ ratePlan.monthlyCharge.original | formatCurrency(true) }} </b></span>
                        <span v-if="ratePlan.quarterlyCharge.original && ratePlan.quarterlyCharge.original > 0"><b>{{ ratePlan.quarterlyCharge.original | formatCurrency(true) }} </b></span>
                        <span v-if="ratePlan.semiAnnualCharge.original && ratePlan.semiAnnualCharge.original > 0"><b>{{ ratePlan.semiAnnualCharge.original | formatCurrency(true) }} </b></span>
                        <span>{{ $t('subscription_details.modifyAccrodion.changeReplenishment.successeffective', ' effective from ') }} {{ subscriptionDetails.nextShipmentDate | formatLocalDate }} </span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="onlyReplenishment">
          <!-- cancelled -->
          <template v-if="onlyReplenishmentCanceled">
            <product
              :returning-status="$t('subscription_return.onlyReplenishment.status.Cancelled', 'Cancelled')"
              :number="subscriptionDetails.number"
              :isBCBSSubscription="subscriptionDetails.isBCBSSubscription"
              :name="subscriptionDetails.title"
              :image="subscriptionDetails.imageUrl"
              :monthly-charge="subscriptionDetails.totalCharge.monthly"
              :quarterly-charge="subscriptionDetails.totalCharge.quarterly"
              :semi-annual-charge="subscriptionDetails.totalCharge.semiAnnual"
              :specific-months-charges="subscriptionDetails.totalCharge.specificMonths"
              :start-date="subscriptionDetails.startDate"
            >
              <template slot="more-info">
                <div class="returnTips ">
                  <p
                    class="tips_returnStatus"
                    v-if="displayCancellationTips"
                    v-once>
                     <span
                      class="tips_replenshipment_cancel"
                      v-html="$t('subscription_details.accordion.popUp.cancellation.content',{
                        paidAmount: subscriptionDetails.paidAmountOfCancelledShipment,
                        remainingAmount: subscriptionDetails.totalAmountOfCancelledShipment - subscriptionDetails.paidAmountOfCancelledShipment,
                        price: subscriptionDetails.priceOfCancelledShipment,
                        finalPaymentDate: replenishmentFinalPaymentDate
                    })"></span>
                  </p>
                </div>
              </template>
            </product>
          </template>

          <!-- returning -->
          <template v-if="onlyReplenishmentReturning">
            <product
              :return-info-status="$t('subscription_return.onlyReplenishment.status.Returning', 'Waiting for return')"
              :number="subscriptionDetails.number"
              :name="subscriptionDetails.title"
              :isBCBSSubscription="subscriptionDetails.isBCBSSubscription"
              :image="subscriptionDetails.imageUrl"
              :monthly-charge="subscriptionDetails.totalCharge.monthly"
              :quarterly-charge="subscriptionDetails.totalCharge.quarterly"
              :semi-annual-charge="subscriptionDetails.totalCharge.semiAnnual"
              :specific-months-charges="subscriptionDetails.totalCharge.specificMonths"
              :start-date="subscriptionDetails.startDate"
              :replenshipment-return-create-date="replenishmentReturnDetails.returnCreatedDate"
            >
              <template slot="more-info">
                <div class="returnTips">
                  <p class="tips_returnStatus" ref="tips_returnStatus" v-if="!subscriptionDetails.isCancelled && (replenishmentReturnDetails.returnStatus === 'Returning')" v-once>
                    <span>{{ $t('subscription_details.onlyReplenishment.returning.tips', 'Your subscription is cancelled, and you will no longer be charged or receive  recurring shipments. You will be  refunded as soon as we have received your product(s)') }}</span>
                  </p>
                </div>
              </template>
            </product>
          </template>

          <!-- normal -->
          <template v-if="!(onlyReplenishmentReturning || onlyReplenishmentCanceled)">
            <product
              :number="subscriptionDetails.number"
              :name="subscriptionDetails.title"
              :image="subscriptionDetails.imageUrl"
              :monthly-charge="subscriptionDetails.totalCharge.monthly"
              :quarterly-charge="subscriptionDetails.totalCharge.quarterly"
              :semi-annual-charge="subscriptionDetails.totalCharge.semiAnnual"
              :specific-months-charges="subscriptionDetails.totalCharge.specificMonths"
              :start-date="subscriptionDetails.startDate"
              :next-shipment-date="subscriptionDetails.nextShipmentDate && !replenishmentPauseWithIndefineDate ? subscriptionDetails.nextShipmentDate : null "
              :list-shipping-frequency="!!onlyReplenishmentFrequency.type ? onlyReplenishmentFrequency : null"
              :next-payment-date="subscriptionDetails.nextPaymentDate"
              :replenshipment-returning-status="subscriptionDetails.status === 'Paused' ? subscriptionDetails.status : null"
              :subscription-detail-replenishment-next-shipment-date="(subscriptionDetails.status === 'Paused' && replenishmentPauseWithIndefineDate) ? true : null"
            >
              <template slot="more-info">
                <div class="pause_tips">
                  <p
                    class="tips_returnStatus"
                    v-if="replenishmentPauseWithIndefineDate"
                    v-once>
                    <span>
                      {{ $t('subscription_details.pauseSubscription.tipsOne', 'Subscription succesfully paused. You can manually resume your subscription anytime.') }}
                    </span>
                  </p>
                  <p
                    class="tips_returnStatus"
                    v-if="replenishmentPauseWithSpecifcDate"
                    v-once>
                    <span>
                      {{ $t('subscription_details.pauseSubscription.tipsTwo', 'Subscription succesfully paused. Your subscription will resume on') }} <b> {{ specificDateFormat }}. </b> {{ $t('subscription_details.pauseSubscription.subTipsTwo', 'You can manually resume your subscription anytime.') }}
                    </span>
                  </p>
                  <p
                    class="tips_returnStatus"
                    v-if="resumeCommonTips">
                    <span>
                      {{ $t('subscription_details.resumeSubscription.successResume.tips', 'Subscription succesfully resumed. Your next shipment is planned for') }} <b> {{ nextShippingDate || resumedNextShippingDate }}. </b>
                    </span>
                  </p>
                  <p
                    class="tips_returnStatus"
                    v-if="replenishmentPauseSubscriptionCommonTips"
                    v-once>
                    <span>
                      {{ $t('subscription_details.pauseSubscription.tipsThree', 'Please note that you can only change your subscription again after the next shipment') }}
                    </span>
                  </p>
                  <div class="changeProductSuccess" v-if="displayChangeReplenishmentSuccessTips.display">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.tips', 'Product type successfully changed to') }}
                        <b>{{ displayChangeReplenishmentSuccessTips.name }}</b>.
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.subTips', 'Your new price') }}
                        <span v-if="subscriptionDetails.totalCharge.monthly.original && subscriptionDetails.totalCharge.monthly.original > 0"> {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
                        <span v-if="subscriptionDetails.totalCharge.quarterly.original && subscriptionDetails.totalCharge.quarterly.original > 0">{{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
                        <span v-if="subscriptionDetails.totalCharge.semiAnnual.original && subscriptionDetails.totalCharge.semiAnnual.original > 0">{{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
                        <template v-if="subscriptionDetails.totalCharge.specificMonths.length>0">
                          <span class="Product_price info_item" v-for="(specificCharge, index) in subscriptionDetails.totalCharge.specificMonths" :key="index">
                            <template v-if="specificCharge.amount.original">
                              <span> {{ specificCharge.months }} {{ $t('common.product.price.specificMonths', 'months') }}</span>
                            </template>
                          </span>
                        </template>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.successwill', ' will be') }}
                        <b>{{ displayChangeReplenishmentSuccessTips.price | formatCurrency(true) }}</b>.
                        <span>{{ $t('subscription_details.modifyAccrodion.changeReplenishment.successeffective', ' effective from ') }} {{ subscriptionDetails.nextShipmentDate | formatLocalDate }}.</span>
                      </span>
                    </p>
                  </div>
                  <div class="changeProductSuccess" v-if="showReplenishmentMsg && (subscriptionDetails.ratePlans[0].amendmentReason === 'ChangeReplenishment-Renew') && !displayChangeReplenishmentSuccessTips.display">
                    <p
                      class="tips_returnStatus"
                      v-once>
                      <span>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.tips', 'Product type successfully changed to') }}
                        <b>{{ subscriptionDetails.title }}</b>.
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.success.subTips', 'Your new price') }}
                        <span v-if="subscriptionDetails.totalCharge.monthly.original && subscriptionDetails.totalCharge.monthly.original > 0"> {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
                        <span v-if="subscriptionDetails.totalCharge.quarterly.original && subscriptionDetails.totalCharge.quarterly.original > 0">{{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
                        <span v-if="subscriptionDetails.totalCharge.semiAnnual.original && subscriptionDetails.totalCharge.semiAnnual.original > 0">{{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
                        <template v-if="subscriptionDetails.totalCharge.specificMonths.length>0">
                          <span class="Product_price info_item" v-for="(specificCharge, index) in subscriptionDetails.totalCharge.specificMonths" :key="index">
                            <template v-if="specificCharge.amount.original">
                              <span> {{ specificCharge.months }} {{ $t('common.product.price.specificMonths', 'months') }}</span>
                            </template>
                          </span>
                        </template>
                        {{ $t('subscription_details.modifyAccrodion.changeReplenishment.successwill', ' will be') }}
                        <span v-if="subscriptionDetails.totalCharge.monthly.original && subscriptionDetails.totalCharge.monthly.original > 0"><b>{{ subscriptionDetails.totalCharge.monthly.original | formatCurrency(true) }}</b></span>
                        <span v-if="subscriptionDetails.totalCharge.quarterly.original && subscriptionDetails.totalCharge.quarterly.original > 0"><b>{{ subscriptionDetails.totalCharge.quarterly.original | formatCurrency(true) }}</b></span>
                        <span v-if="subscriptionDetails.totalCharge.semiAnnual.original && subscriptionDetails.totalCharge.semiAnnual.original > 0"><b>{{ subscriptionDetails.totalCharge.semiAnnual.original | formatCurrency(true) }}</b></span>
                        <span>{{ $t('subscription_details.modifyAccrodion.changeReplenishment.successeffective', ' effective from ') }} {{ subscriptionDetails.nextShipmentDate | formatLocalDate }}.</span>
                      </span>
                    </p>
                  </div>
                </div>
              </template>
            </product>
          </template>
        </template>

        <!-- :subscription-return-status="subscriptionDetails.returnInfoDetails" -->
        <subscription-details-accordion
          :subscription-rate-plans="subscriptionDetails.ratePlans"
          :subscription-number="subscriptionDetails.number"
          :subscription-one-time-orders="subscriptionDetails.oneTimeOrders"
          :replenishment-only="subscriptionDetails.replenishmentOnly"
          :accept-promotion="subscriptionDetails.acceptPromotion"
          :has-discount="subscriptionDetails.hasDiscount"
          :hide-pay-in-full="subscriptionDetails.hidePayInFull"
          :try-buy-return-details="tryBuyReturnDetails"
          :replenishment-return-details="replenishmentReturnDetails"
          @resume-success="confirmResumeReplenshipment"
        />
      </div>
    </template>
    <generic-custom-code
      :generic-script="subscriptionDetails.genericScript"
      :generic-html="subscriptionDetails.genericHtml"
    />
  </div>
</template>
<script>
  import SubscriptionDetailsAccordion from 'components/SubscriptionDetailsAccordion'
  import SubscriptionPageMixin from 'mixins/subscription-page'
  import GenericCustomCode from 'components/GenericCustomCode'
  import { find } from 'lodash'

  export default {
    name: 'subscription-details',

    components: {
      SubscriptionDetailsAccordion,
      GenericCustomCode
    },

    data () {
      return {
        listShippingFrequency: {
          type: null,
          specific: null
        },
        confirmResumeSuccess: false,
        nextShippingDate: null,
        displayChangeReplenishmentSuccessTips: {}
      }
    },

    mixins: [SubscriptionPageMixin],

    computed: {
      ratePlanPayInFull () {
        return find(this.subscriptionDetails.ratePlans, { status: 'PayInFull' })
      },

      onlyReplenishment () {
        return this.subscriptionDetails.ratePlans.length === 1 &&
          (this.subscriptionDetails.ratePlans[0].modelType === 'Replenishment' || this.subscriptionDetails.ratePlans[0].modelType === 'ReplenishmentStandard')
      },

      tryBuyRatePlan () {
        return find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuy' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyPurchase' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciation' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'TryBuyDepreciationPurchase' }) ||
          find(this.subscriptionDetails.ratePlans, { modelType: 'Buy&Subscribe-standard' }) 

      },

      onlyReplenishmentRatePlan () {
        return this.subscriptionDetails.ratePlans.length === 1 && find(this.subscriptionDetails.ratePlans, { modelType: 'Replenishment' }) ||
         find(this.subscriptionDetails.ratePlans, { modelType: 'ReplenishmentStandard' })
      },

      onlyReplenishmentFrequency () {
        Object.assign(this.listShippingFrequency, {
          type: this.onlyReplenishmentRatePlan.shippingFrequency && this.onlyReplenishmentRatePlan.shippingFrequency.billingPeriod,
          specific: this.onlyReplenishmentRatePlan.shippingFrequency && this.onlyReplenishmentRatePlan.shippingFrequency.specificBillingPeriod
        })
        return this.listShippingFrequency
      },

      deviceFromBundles () {
        return this.subscriptionDetails.ratePlans.length > 1 && find(this.subscriptionDetails.ratePlans, { modelType: 'Replenishment' }) ||
        find(this.subscriptionDetails.ratePlans, { modelType: 'ReplenishmentStandard' })
      },

      bundlesReplenishmentFrequency () {
        Object.assign(this.listShippingFrequency, {
          type: this.deviceFromBundles.shippingFrequency && this.deviceFromBundles.shippingFrequency.billingPeriod,
          specific: this.deviceFromBundles.shippingFrequency && this.deviceFromBundles.shippingFrequency.specificBillingPeriod
        })
        return this.listShippingFrequency
      },

      tryBuyReturnDetails () {
        return this.subscriptionDetails.returnInfoDetails && this.subscriptionDetails.returnInfoDetails.tryBuyReturnDetails
      },

      replenishmentReturnDetails () {
        return this.subscriptionDetails.returnInfoDetails && this.subscriptionDetails.returnInfoDetails.replenishmentReturnDetails
      },

      replenishmentFinalPaymentDate () {
        const replenishmentFinalPaymentDate = this.$options.filters.formatLocalDate(this.subscriptionDetails.finalPaymentDateOfCancelledShipment)
        return replenishmentFinalPaymentDate
      },

      replenishmentPauseWithIndefineDate () {
        return this.subscriptionDetails.pausedReplenishmentDate && this.subscriptionDetails.ableToResumeReplenishment
      },

      replenishmentPauseWithSpecifcDate () {
        return (!this.subscriptionDetails.ableToResumeReplenishment && this.subscriptionDetails.resumedReplenishmentDate &&
          !this.subscriptionDetails.pausedReplenishmentDate) && !this.resumeCommonTips
      },

      replenishmentPauseSubscriptionCommonTips () {
        return (((!this.subscriptionDetails.ableToResumeReplenishment && this.subscriptionDetails.resumedReplenishmentDate) ||
          this.subscriptionDetails.pausedReplenishmentDate) && this.replenishmentReturnDetails &&
          this.replenishmentReturnDetails.returnStatus !== 'Returning' && this.replenishmentReturnDetails.returnStatus !== 'None')
      },

      resumeCommonTips () {
        return (this.subscriptionDetails.displayResumeTips &&
        (!this.subscriptionDetails.ableToChangeReplenishmentResumeDate && !this.subscriptionDetails.ableToResumeReplenishment))
      },

      displayCancellationTips () {
        return !this.subscriptionDetails.ableToCancelReplenishment &&
          this.subscriptionDetails.priceOfCancelledShipment &&
          this.subscriptionDetails.totalAmountOfCancelledShipment > this.subscriptionDetails.paidAmountOfCancelledShipment &&
          new Date().getTime() < new Date(this.subscriptionDetails.finalPaymentDateOfCancelledShipment).getTime()
      },

      onlyReplenishmentCanceled () {
        return this.replenishmentReturnDetails &&
          (this.replenishmentReturnDetails.unreturnableReason === 'SubscriptionCancelled' ||
          this.replenishmentReturnDetails.unreturnableReason === 'RatePlanCancelled')
      },

      onlyReplenishmentReturning () {
        return !this.subscriptionDetails.isCancelled && (this.replenishmentReturnDetails &&
          this.replenishmentReturnDetails.returnStatus === 'Returning')
      },

      showReplenishmentMsg () {
        let nextShipmentDate = new Date(this.subscriptionDetails.nextShipmentDate).setHours(0, 0, 0, 0)
        let currentDate = new Date().setHours(0, 0, 0, 0)
        let pastShipmentDate = false
        if (nextShipmentDate < currentDate) {
          pastShipmentDate = true
        }
        return this.subscriptionDetails.hasAnyFutureDatedReplenishment &&
          (this.subscriptionDetails.bundleType === 'Bundle' || this.subscriptionDetails.bundleType === 'ReplenishmentOnly') && !pastShipmentDate
      }
    },

    methods: {
      confirmResumeReplenshipment () {
        this.confirmResumeSuccess = true
        this.nextShippingDate = `${new Date(this.subscriptionDetails.nextShipmentDate).toDateString().split(' ')[1]} ${new Date(this.subscriptionDetails.nextShipmentDate).getDate()}, ${new Date(this.subscriptionDetails.nextShipmentDate).getFullYear()}`
      }
    },

    mounted () {
      const changePaymentAndPayInfullResult = window.localStorage.getItem('changePaymentAndPayInfullResult')
      this.$bus.$on('display-change-success-tips', displayChangeReplenishmentSuccessTip => {
        this.displayChangeReplenishmentSuccessTips = displayChangeReplenishmentSuccessTip
      })
      if (changePaymentAndPayInfullResult && changePaymentAndPayInfullResult === 'failed') {
        this.$notify({
          type: 'error',
          title: this.$t('subscription_purchase.popuptips.purchase.failed', 'Purchase failed, please try again!')
        })
        window.localStorage.removeItem('changePaymentAndPayInfullResult')
      }
    }
  }
</script>

<style lang="scss">
  .PriceBox {
    background: $white;
    border: .02rem solid $blue;
    padding: .14rem .16rem;
    text-align: center;
    margin-bottom: .1rem;

    .title {
      color: $font-black;
      font-size: .21rem;
      font-weight: 300;
    }

    .amount {
      color: $blue;
      font-size: .34rem;
      font-weight: 800;
      line-height: .42rem;
    }
  }

  .returnTips {
    margin-top: .24rem;

    .tips_returnStatus {
      background-color: #fdf5d7;
      font-size: .14rem;
      color: #de7510;
      line-height: .22rem;
      padding: .11rem;
      margin-bottom: .15rem;

      @include media(tablet) {
        padding: .11rem;
      }

      .closeButton::before,
      ::after {
        right: 50px;
        top: 61%;
        background-color: #5f9920;
        cursor: pointer;

        @include media(tablet) {
          top: 62%;
        }
      }
    }
  }

  .changeProductSuccess {
    margin-top: .24rem;

    .tips_returnStatus {
      background-color: #f7fad4;
      font-size: .14rem;
      color: #5f9920;
      line-height: .22rem;
      padding: .11rem;
      margin-bottom: .15rem;

      @include media(tablet) {
        padding: .11rem;
      }

      .closeButton::before,
      ::after {
        right: 50px;
        top: 61%;
        background-color: #5f9920;
        cursor: pointer;

        @include media(tablet) {
          top: 62%;
        }
      }
    }
  }

  .SubscriptionDetailsPage {
    .SubscriptionDetailsPage_product {
      border: .01rem solid #e8e8e8;
      margin-bottom: .24rem;

      &_bundle {
        border: 0;
      }

      hr {
        border-bottom: .01rem solid #e8e8e8;
        margin: 0 .32rem;
      }

      .bundle-ratePlan {
        .Product {
          border: 0;
          padding: .2rem 0 0;
        }
      }
    }

    .product_subset_detail {
      .Product_info {
        .Product_name {
          font-size: .16rem;
          font-weight: bold;
          line-height: .2rem;
          letter-spacing: -.0022rem;
        }

        .Product_content {
          .Product_price {
            margin: .04rem 0 0;
            font-size: .14rem;
            letter-spacing: -.0027rem;
            line-height: .28rem;
          }

          .Product_returnStatus {
            margin-bottom: 0;
          }

          .Product_info_align {
            line-height: .18rem;
            font-size: .14rem;
            font-weight: 400;
            margin-bottom: .04rem;
            padding-right: 0;

            @include media(tablet) {
              display: flex;
              justify-content: space-between;
            }
          }
        }
      }

      .img-holder {
        @include media(tablet) {
          max-width: 1.39rem;
          max-height: 1.63rem;
        }

        .Product_img {
          @include media(tablet) {
            max-width: 1.39rem;
            max-height: 1.63rem;
          }
        }
      }
    }

    .Product_info {
      .Product_content {
        max-width: 3.75rem;

        .Product_price {
          margin: 0 0 .11rem;

          span {
            display: inline-block;
            display: -ms-inline-grid;
          }
        }

        .Product_returnStatus {
          margin-bottom: .1rem;
        }

        .Product_info_align {
          display: flex;
          justify-content: space-between;

          @include media(tablet) {
            display: flex;
            justify-content: space-between;
          }

          span:nth-of-type(2) {
            width: 40%;
          }

          span:nth-of-type(1) {
            max-width: 60%;
          }
        }

        .Product_returnStatus.Product_info_align {
          display: inline-block;

          .Product_returnCreateDate-warning {
            font-weight: 500;
          }
        }

        @include media(tablet) {
          max-width: 3.69rem;
        }
      }
    }
  }

  .tips_returnStatus {
    background-color: #f7fad4;
    font-size: .14rem;
    color: #de7510;
    line-height: .22rem;
    padding: .11rem .16rem;
    margin-bottom: .15rem;

    @include media(tablet) {
      padding: .11rem .26rem;
    }

    .closeButton::before,
    .closeButton::after {
      content: '';
      position: absolute;
      display: block;
      width: .2rem;
      height: .017rem;
      top: 88%;
      right: .25rem;
      transform: rotate(48deg);
      background-color: $blue;
    }

    .closeButton::after {
      transform: rotate(-48deg);
    }
  }

  .pause_tips {
    margin-top: .1rem;

    .tips_returnStatus {
      color: #5f9920;
      background-color: #f7fad4;
    }
  }
</style>
